module.exports = __webpack_public_path__ + "img/clip.628fead.svg?v=1764823240413";